<template>
    <ul class="multi-select__list">
        <li v-for="option in select.options" :key="option.id" class="multi-select__item">
            <div class="checkbox checkbox_size_small checkbox_theme_dark">
                <input type="checkbox"
                       :name="select.name"
                       :id="`${select.name}-${option.id}-${view}`"
                       :value="option.value"
                       :disabled="option.disabled"
                       class="checkbox__input"
                       v-model="option.selected"
                       @change="change">
                <label :for="`${select.name}-${option.id}-${view}`" class="checkbox__label">
                    <span class="checkbox__icon">
                        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 3L4.5 6.5L10 1"></path>
                        </svg>
                    </span>
                    <span class="checkbox__text">{{ option.text }}</span>
                </label>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['select', 'view'],

    methods: {
        change() {
            this.$emit('changeFilter');
        }
    }
};
</script>
